import { Link } from "react-router-dom";

const footerLinks = {
  快速导航: [
    { label: "资源推荐", path: "/category/ziyuan-tuijian" },
    { label: "风格解析", path: "/category/fengge-jiexi" },
    { label: "创作教程", path: "/category/chuangzuo-jiaocheng" },
    { label: "购买指南", path: "/category/goumai-zhinan" },
    { label: "文化赏析", path: "/category/wenhua-shangxi" },
  ],
  关于我们: [
    { label: "品牌介绍", path: "/about" },
    { label: "联系我们", path: "/about" },
  ],
  友情链接: [
    { label: "Comic Market", path: "https://www.comiket.co.jp/", external: true },
    { label: "Pixiv", path: "https://www.pixiv.net/", external: true },
    { label: "DLsite", path: "https://www.dlsite.com/", external: true },
    { label: "BOOTH", path: "https://booth.pm/", external: true },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-14 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </span>
              <span className="font-semibold text-lg text-background-50">本子漫画导航</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/60">
              正版资源导航与创作指南，为漫画爱好者提供最全面、最专业的内容服务。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-semibold text-sm text-background-50 mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) =>
                  link.external ? (
                    <li key={link.label}>
                      <a
                        href={link.path}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="text-sm text-background-50/60 hover:text-primary-400 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <Link to={link.path} className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                        {link.label}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-background-50/50">
            &copy; {new Date().getFullYear()} 本子漫画导航 HonkoManga-Nav. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-background-50/50 text-sm">
            <span>contact@honkomanga-nav.com</span>
            <span>微博 @本子漫画导航</span>
          </div>
        </div>
      </div>
    </footer>
  );
}